module.exports = __webpack_public_path__ + "img/icon-1.afe5335c.png";